import { NotifyHelper } from "../../../helpers/toast";
import { eBienLaiViewChiTietActionsObj } from "../../action-types/bien-lai/IBienLaiViewChiTietActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const bienLaiViewChiTietActions = {
  ...generateActions(eBienLaiViewChiTietActionsObj, "BIEN_LAI_VIEW_CHI_TIET"),
  ...generateActionForKey(
    eBienLaiViewChiTietActionsObj,
    "BIEN_LAI_VIEW_CHI_TIET",
    "PRINT_ERR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
};
